import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { useReorderPrefillState } from '../../modules/inventory/reorder-sheet/use-reorder-prefill-state.js';
import { TransferOrderCreateForm } from '../../modules/transfer-orders/transfer-order-create-form.js';

export const Route = createFileRoute('/transfer-orders/new')({
  component: NewTransferOrderPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- route files export both Route and their page component; fast refresh flags the second export
function NewTransferOrderPage() {
  const { prefill, returnTo } = useReorderPrefillState('NEW_TO');
  return (
    <RouteGuard route="/transfer-orders/new">
      <div>
        <TransferOrderCreateForm reorderPrefill={prefill} returnTo={returnTo} />
      </div>
    </RouteGuard>
  );
}
